import branchAndServicePoint from 'locales/dental/en/setting/branch-service-point.json'
import defaultLab from 'locales/dental/en/setting/default-labs.json'
import defaultProduct from 'locales/dental/en/setting/default-products.json'
import defaultUsers from 'locales/dental/en/setting/default-users.json'
import defaultSetting from 'locales/dental/en/setting/defaults.json'
import dfManagement from 'locales/dental/en/setting/doctor-fee-managements.json'
import cfManagement from 'locales/dental/en/setting/credit-fee-managements.json'
import finance from 'locales/dental/en/setting/finances.json'
import personalManagement from 'locales/dental/en/setting/personnel-managements.json'
import treatmentCourse from 'locales/dental/en/setting/treatment-courses.json'
import treatmentPlan from 'locales/dental/en/setting/treatment-plans.json'
import treatmentRight from 'locales/dental/en/setting/treatment-rights.json'
import treatment from 'locales/dental/en/setting/treatments.json'
import doctorNote from 'locales/dental/en/setting/doctor-note.json'
import formatForm from 'locales/dental/en/setting/branch-format-form.json'
import breakManagement from 'locales/dental/en/setting/break-management.json'

export const SettingEN = {
  ...branchAndServicePoint,
  ...defaultLab,
  ...defaultProduct,
  ...defaultUsers,
  ...defaultUsers,
  ...defaultSetting,
  ...dfManagement,
  ...finance,
  ...personalManagement,
  ...treatmentCourse,
  ...treatmentPlan,
  ...treatmentRight,
  ...treatment,
  ...doctorNote,
  ...cfManagement,
  ...formatForm,
  ...breakManagement
}
